'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomValueCombo = exports.getCustomValueNoOptions = exports.getCustomValue = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCustomValue(value, options) {
  if (_lodash2.default.isEmpty(options) || value === undefined || value === null || value === '') {
    return null;
  } else if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
    return value.length > 0 ? value : null;
  }
  if (value.toString().indexOf(',') > 0) {
    var objValue = _lodash2.default.split(value, ',');
    if (objValue.length > 0) {
      var arr = [];
      _lodash2.default.forEach(objValue, function (value) {
        var obj = _lodash2.default.find(options, function (o) {
          return o.value == value;
        });
        if (obj) {
          arr.push(obj);
        }
      });
      return arr.length > 0 ? arr : null;
    }
  }
  return _lodash2.default.find(options, function (o) {
    return o.value == value;
  });
}

function getCustomValueCombo(value, options) {
  if (_lodash2.default.isEmpty(options) || value === undefined || value === null || value === '') {
    return null;
  } else if (_lodash2.default.isArray(value)) {
    if (value.length > 0) {
      var arr = [];
      _lodash2.default.forEach(value, function (val) {
        var obj = searchTree({ options: options }, val);
        if (obj) {
          arr.push(obj);
        }
      });
      return arr.length > 0 ? arr : null;
    }
    return null;
  }
  return searchTree({ options: options }, value);
}

function searchTree(element, value) {
  if (element.value == value) {
    return element;
  } else if (element.options != null) {
    var i = void 0;
    var result = null;
    for (i = 0; result == null && i < element.options.length; i++) {
      result = searchTree(element.options[i], value);
    }
    return result;
  }
  return null;
}

function getCustomValueNoOptions(value, defaultValue) {
  if (!value) {
    return defaultValue || [];
  } else if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
    return value;
  }
  var objValue = _lodash2.default.split(value, ',');
  if (objValue.length > 0) {
    var arr = [];
    _lodash2.default.forEach(objValue, function (value) {
      var obj = { value: value, label: value };
      arr.push(obj);
    });
    return arr;
  }

  return { value: value, label: value };
}

exports.getCustomValue = getCustomValue;
exports.getCustomValueNoOptions = getCustomValueNoOptions;
exports.getCustomValueCombo = getCustomValueCombo;